import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { SplitWords } from "./motionHelpers";

export default function D2Banner({ eyebrow, title, subtitle, image, crumbs = [] }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.05, 1.18]);

  return (
    <section ref={ref} className="relative pt-[74px] overflow-hidden bg-[#06170f]">
      {image && (
        <>
          <motion.img src={image} alt={title} style={{ y, scale }} className="absolute inset-0 w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#06170f] via-[#06170f]/70 to-[#06170f]/40" />
        </>
      )}
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 lg:px-8 py-24 md:py-32">
        <nav className="flex items-center gap-2 font-grotesk uppercase text-xs tracking-widest text-sc-lime mb-5 flex-wrap">
          <Link to="/" className="hover:text-white">Home</Link>
          {crumbs.map((c) => (
            <span key={c.label} className="flex items-center gap-2">
              <ChevronRight className="w-3 h-3" />
              {c.to ? <Link to={c.to} className="hover:text-white">{c.label}</Link> : <span className="text-white/60">{c.label}</span>}
            </span>
          ))}
        </nav>
        {eyebrow && <span className="font-grotesk uppercase tracking-[0.3em] text-sc-orange text-sm">{eyebrow}</span>}
        <h1 className="font-display uppercase text-5xl md:text-8xl text-white leading-[0.88] mt-3">
          <SplitWords text={title} />
        </h1>
        {subtitle && <p className="text-white/75 text-lg mt-5 max-w-2xl font-grotesk">{subtitle}</p>}
      </div>
    </section>
  );
}
